import React from 'react'
import { Link } from 'react-router-dom'
import phone_view from '../images/phone_view.jpg'
function WecomePage() {
    return (
        <>
            <div className='h1'>
                <div className='row'>
                    <div className='col-xl-2 col-md-2 col-sm-1 col-sm-1'></div>
                    <div className='col-xl-8 col-sm-10 col-md-8 col-xs-10 flex text-primary text-center  text-primary mt-4'>
                        Showcase and share your virtual portfolio with style and ease
                    </div>
                </div>
            </div>
            <div className='m-4'>
            </div>
            <div className='f-flex justify-content-center align-items-center'>
                <div className='row mt-5 mb-4'>
                    <div className='col-4'></div>
                    <div className='col-md-2 row-sm p-2 m-1 d-flex justify-content-center' >
                        <Link to='signin' className='btn btn-secondary text-primary'>Sign In</Link>
                    </div>
                    <div className='col-md-2 row-sm p-2 m-1 d-flex justify-content-center'>
                        <Link to='/signup' className='btn btn-secondary text-primary '>Get started</Link>
                    </div>

                </div>
            </div>
            <div className='row '>
                <div className='col-2'></div>
                <div className='col-8 flex text-primary text-center h3 mt-4 ml-1'>
                    Get your own url and use it anywhere anytime!
                    <div className='mt-4 mb-3' style={{ fontSize: "0.8em" }}><small>https://link-show-case.web.app/your_name</small></div>
                </div>
            </div>
            <div className='row'>
                <div className='col-2'></div>
                <div className='col-8 flex text-primary text-center h3 mt-5 ml-1'>
                    <img className='img-fluid' alt='preview' src={phone_view}></img>
                </div>
            </div>
            <div className='row'>
                <div className='col-2'></div>
                <div className='col-8 flex text-primary text-center h2 mt-5 ml-1 mb-5'>
                    Get Started now!
                </div>
            </div>

        </>
    )
}

export default WecomePage
